import { SceneTemplate } from "@/lib/utils/lomda/types";

export const templateB: SceneTemplate = {
    name: "תבנית ב",
    branding: {
        background: "primary",
        foreground: undefined,
    },
    aspectRatio: "16:9",
    avatar: undefined,
    scene: {
        scale: 80,
        rounded: true,
        location: {
            x: 10,
            y: 10,
        },
    },
};
